import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=88669182&scoped=true"
import script from "./order-list.vue?vue&type=script&lang=ts"
export * from "./order-list.vue?vue&type=script&lang=ts"
import style0 from "./order-list.vue?vue&type=style&index=0&id=88669182&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88669182",
  null
  
)

export default component.exports